import { ReactNode, PropsWithChildren, FC, CSSProperties } from 'react'

import getColor from '~/lib/getColor'

import styles from './styles.css'

const CLIPPING = 'polygon(0 0, 100% 0, 80% 100%, 20% 100%)'

const Shroud: FC<
    PropsWithChildren<{
        overlay?: boolean
        bgColor: string
        textColor?: string
        clip?: boolean
        borderRadius?: string
        visible?: boolean
        width?: string
        title: ReactNode
    }>
> = ({
    children,
    bgColor,
    textColor = 'white',
    clip = false,
    overlay = false,
    borderRadius = '0',
    visible = false,
    width = '4px',
    title,
}) => {
    const shroudConfig: CSSProperties = {
        position: 'absolute',
        borderColor: getColor(bgColor),
        borderWidth: width,
        borderStyle: 'solid',
        borderRadius: borderRadius,
    }

    const shroudTextConfig: CSSProperties = {
        backgroundColor: getColor(bgColor),
        color: getColor(textColor),
        clipPath: clip ? CLIPPING : '',
        position: overlay ? 'absolute' : 'relative',
        borderRadius: borderRadius,
    }

    return visible ? (
        <div className={styles.shroudPositionWrapper}>
            <div className={styles.shroud} style={shroudConfig} />
            <div className={styles.shroudText} style={shroudTextConfig}>
                {title}
            </div>
            {children}
        </div>
    ) : (
        <>{children}</>
    )
}

export default Shroud
